import { useCallback, useEffect, useRef } from 'react';

const useThrottleCallback = <T extends Function>(callback: T, throttleTime = 1000) => {
  const currentThrottle = useRef<number | null>(null);

  const throttledCallback = useCallback(() => {
    if (currentThrottle.current) {
      window.clearTimeout(currentThrottle.current);
    }
    currentThrottle.current = window.setTimeout(() => {
      callback();
    }, throttleTime);
  }, [callback, throttleTime]);

  useEffect(
    () => () => {
      if (currentThrottle.current) {
        window.clearTimeout(currentThrottle.current);
      }
    },
    []
  );

  return throttledCallback;
};

export default useThrottleCallback;
